export default "__VITE_ASSET__waRAngvA__"